import { FormControlLabel, Hidden, Radio, RadioGroup, Slider } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';

const products = {
	monthly: {
		landed1: {
			fee: 49.99,
			interest: 0.283282724670457,
			factor: 0.09666667,
			totalInstalments: 12,
		},
		landed2: {
			fee: 53.99,
			interest: 0.408837640517603,
			factor: 0.061666,
			totalInstalments: 24,
		},
		settled: {
			fee: 55.99,
			interest: 0.229922176380833,
			factor: 0.028186,
			totalInstalments: 60,
		},
	},
	biweekly: {
		landed1: {
			fee: 21.99,
			interest: 0.283282724670457,
			factor: 0.04437391,
			totalInstalments: 26,
		},
		landed2: {
			fee: 22.99,
			interest: 0.408837640517603,
			factor: 0.02829548,
			totalInstalments: 52,
		},
		settled: {
			fee: 26.99,
			interest: 0.229922176380833,
			factor: 0.01297345,
			totalInstalments: 130,
		},
	},
};

const getDateDue = (initialDate, frequency, instalments) => {
	return '15/02/2022';
};

// const pchFormatter = new Intl.NumberFormat('en-US', {
// 	style: 'currency',
// 	currency: 'USD',
// 	maximumFractionDigits: 2,
// });

function Calculator() {
	const [instalment, setInstalment] = useState(0);
	const [frequency, setFrequency] = useState('biweekly');
	const [duration, setDuration] = useState('settled');
	const [amount, setAmount] = useState(5000);
	const [disableOptions, setDisabledOptions] = useState({ landed1: false, landed2: false, settled: false });
	const [totalInstalments, setTotalInstalments] = useState(0);

	const handleAmount = e => {
		setAmount(parseFloat(e.target.value));
	};

	const refreshTable = useCallback((amount, frequency, duration, instalment, info) => {
		let years = 5;
		if (duration === 'landed1') years = 1;
		if (duration === 'landed2') years = 2;

		const multiplier = frequency === 'biweekly' ? 26 : 12;

		const instalments = years * multiplier;
		const initialDate = new Date();
		const table = [];

		let balance = amount;

		for (let i = 0; i < instalments; i++) {
			const dateDue = getDateDue(initialDate, frequency, instalments);
			const principal = balance;
			const interest = principal * (info.interest / multiplier);
			const amortization = instalment - info.fee - interest;
			balance = principal - amortization;
			const row = {
				paymentNumber: i + 1,
				dateDue,
				principal,
				interestRate: info.interest / multiplier,
				interest,
				amortization,
				fee: info.fee,
				payment: instalment,
				balance,
			};
			table.push(row);
		}

		// setAmortizationTable(table);
	}, []);

	useEffect(() => {
		console.log('amount', amount);
		if (amount > 0) {
			const info = products[frequency][duration];
			setTotalInstalments(info.totalInstalments);

			if (amount < 3000) {
				setDuration('landed1');

				setDisabledOptions({
					landed1: false,
					landed2: true,
					settled: true,
				});
			} else if (amount === 3000) {
				if (duration === 'settled') setDuration('landed2');
				setDisabledOptions({
					landed1: false,
					landed2: false,
					settled: true,
				});
			} else if (amount > 3000 && amount < 5000) {
				if (duration === 'settled') setDuration('landed2');

				setDisabledOptions({
					landed1: true,
					landed2: false,
					settled: true,
				});
			} else if (amount === 5000) {
				if (duration === 'landed1') setDuration('settled');

				setDisabledOptions({
					landed1: true,
					landed2: false,
					settled: false,
				});
			} else if (amount > 5000) {
				setDuration('settled');

				setDisabledOptions({
					landed1: true,
					landed2: true,
					settled: false,
				});
			}

			const tempInstalment = amount * info.factor + info.fee;
			setInstalment(tempInstalment);
		} else {
			setInstalment(0);
		}
	}, [amount, frequency, duration, refreshTable]);

	const handleFrequencySelect = useCallback(e => {
		setFrequency(e.target.value);
	}, []);

	const handleDurationSelect = useCallback(e => {
		setDuration(e.target.value);
	}, []);

	const sliderFormat = (value, index) => {
		return `$ ${value}`;
	};

	const handleApply = () => {
		var win = window.open('/apply-now', '_blank');
		win.focus();
	};

	const handleAmountChange = e => {
		if (isNaN(e.target.value)) {
			setAmount(0);
		}
		setAmount(e.target.value);
	};

	const handleAmountBlur = e => {
		if (isNaN(e.target.value)) {
			setAmount(1500);
		}

		if (e.target.value < 1500) {
			setAmount(1500);
		} else if (e.target.value > 10000) {
			setAmount(10000);
		}
	};

	return (
		<div className='p-4'>
			<div className='grid grid-cols-1 md:grid-cols-3 gap-4 shadow-xl rounded-t-3xl rounded-b-3xl md:rounded-r-3xl text-center md:text-left'>
				<div className='md:flex h-full'>
					{/* Aqui tengo los dos divs, que en movil esta uno debajo del otro y en md uno al lado del otro */}
					<div className='bg-gradient-to-b md:bg-gradient-to-r from-[#90FFBE] to-[#86CDFF]  flex items-center justify-center flex-col flex-auto pt-8 md:pt-0 rounded-t-3xl md:rounded-l-3xl md:rounded-tl-3xl md:rounded-t-none'>
						<div className='text-[#112446]'>
							You will pay {totalInstalments} {frequency === 'biweekly' ? 'Bi-Weekly' : 'Monthly'} instalments
							of:
						</div>{' '}
						{amount > 10000 || amount < 1500 ? (
							<div className='mt-4 text-center'>
								Amount must be <br />
								between 1,500 and 10,000
							</div>
						) : (
							<div className='text-center text-[#112446] w-full text-5xl font-extrabold mt-4'>
								${instalment.toFixed(2)}
							</div>
						)}
						<div
							className='w-[50%] bg-black text-white rounded-full text-sm text-center p-2 shadow-xl mt-8 cursor-pointer'
							onClick={handleApply}
						>
							APPLY NOW!
						</div>
						<div className='text-[#112446] text-center text-xs mt-8'>
							Applying will not impact your credit score. <br />
						</div>
					</div>
					{/* en este cambio el estilo para que sea arriba o abajo el border */}
					<div className='bg-[#86CDFF] w-20 h-10 md:h-full down-arrow md:right-arrow flex-1'></div>
				</div>
				<div className='md:col-span-2 p-4 bg-white rounded-b-3xl md:rounded-r-3xl'>
					<div className='text-2xl my-4 md:text-left'>
						Write Your Loan Amount: <span className='font-extrabold text-gray-800'>$ </span>
						<span className='text-3xl md:text-4xl font-bold'>
							<input
								onBlur={handleAmountBlur}
								value={amount}
								onChange={handleAmount}
								variant='standard'
								className='w-36 font-extrabold text-gray-800 border-b-2 border-gray-800'
								min='1500'
								max='10000'
								type='number'
							/>
						</span>
						<br />
						<div className='text-xs mb-8'>Or slide the blue dot</div>
					</div>
					<div className='flex my-4' style={{ width: '90%' }}>
						<div className='flex-auto md:text-left'>Min:$1,500.00</div>
						<div>Max:$10,000.00</div>
					</div>
					<div className='w-full'>
						<Slider
							valueLabelDisplay='auto'
							valueLabelFormat={sliderFormat}
							aria-label='pretto slider'
							value={amount}
							min={1500}
							max={10000}
							style={{ width: '90%' }}
							onChange={e => setAmount(e.target.value)}
						/>
					</div>
					<div className='md:flex items-center gap-2'>
						<div className='md:flex-initial'>Payment Frequency:</div>
						<div className='flex flex-col items-center md:flex-none'>
							<RadioGroup
								row
								aria-label='position'
								name='position'
								value={frequency}
								className=''
								onChange={handleFrequencySelect}
							>
								<FormControlLabel
									value='biweekly'
									control={<Radio color='primary' />}
									label='Bi-Weekly'
									labelPlacement='end'
								/>
								<FormControlLabel
									value='monthly'
									control={<Radio color='primary' />}
									label='Monthly'
									labelPlacement='end'
								/>
							</RadioGroup>
						</div>
					</div>
					<div className='md:flex items-center gap-2'>
						<div>Term:</div>
						<div className='flex flex-col items-center md:flex-none md'>
							<RadioGroup
								row
								aria-label='position'
								name='position'
								defaultValue='settled'
								value={duration}
								onChange={handleDurationSelect}
							>
								<FormControlLabel
									value='landed1'
									control={<Radio color='primary' />}
									label='1 Year'
									labelPlacement='end'
									disabled={disableOptions.landed1}
								/>
								<FormControlLabel
									value='landed2'
									control={<Radio color='primary' />}
									label='2 Years'
									labelPlacement='end'
									disabled={disableOptions.landed2}
								/>
								<FormControlLabel
									value='settled'
									control={<Radio color='primary' />}
									label='5 Years'
									labelPlacement='end'
									disabled={disableOptions.settled}
								/>
							</RadioGroup>
						</div>
					</div>
					<div className='text-xs my-2'>
						*Applicants are subject to approval. Additional steps are required to effectively apply for a Loan
						with SimplyBorrowed Inc.{' '}
					</div>
				</div>
			</div>

			{/* <div className='md:col-span-3'>
				{view?.version === 'short' ? (
					<div className='border-[#606060] border-2 border-dashed border-t-0 w-[90%] mx-auto p-2 text-center rounded-b-2xl'>
						<span className='text-xs uppercase underline text-[#606060] cursor-pointer' onClick={handleApply}>
							See the full payment schedule
						</span>
					</div>
				) : (
					<div className='border-[#606060] border-2 border-dashed border-t-0 w-[90%] mx-auto p-2 text-center rounded-b-2xl'>
						<table className='w-full text-sm'>
							<thead>
								<tr>
									<td>#</td>
									<td>Principal</td>
									<td>I. Rate</td>
									<td>Interest*</td>
									<td>Amortization</td>
									<td>Fee</td>
									<td>Payment</td>
									<td>Balance *</td>
								</tr>
							</thead>
							<tbody>
								{amortizationTable.map(row => (
									<tr key={row.paymentNumber}>
										<td>{row.paymentNumber}</td>
										<td>{pchFormatter.format(row.principal)}</td>
										<td>{(row.interestRate * 100).toFixed(2)}%</td>
										<td>{pchFormatter.format(row.interest)}</td>
										<td>{pchFormatter.format(row.amortization)}</td>
										<td>{pchFormatter.format(row.fee)}</td>
										<td>{pchFormatter.format(row.payment)}</td>
										<td>{row.balance < 0 ? '0.00' : pchFormatter.format(row.balance)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</div> */}
		</div>
	);
}

export default Calculator;
